import {
  Clock, Truck, Package, MapPin, Building2, Siren, ShieldCheck,
  Navigation, UserCheck, CalendarClock, BadgeDollarSign, Headset,
  PhoneCall, Boxes, PackageCheck,
} from "lucide-react";

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why" },
  { label: "Process", href: "#process" },
  { label: "Fleet", href: "#fleet" },
  { label: "Contact", href: "#contact" },
];

export const HERO_STATS = [
  { value: "99.2%", label: "On-Time Rate", icon: Clock },
  { value: "1K+", label: "Parcels Delivered", icon: ShieldCheck },
  { value: "24/7", label: "Same-Day Available", icon: PhoneCall },
];

export const ABOUT_CARDS = [
  {
    title: "Who We Are",
    body: "On Time Couriers is a specialized medical delivery service dedicated to providing the highest standard of professional courier services in the healthcare industry. With years of experience handling time-sensitive medical shipments, we understand that precision, reliability, and integrity are non-negotiable.",
  },
  {
    title: "Our Commitment to Professionalism",
    body: "Every member of our team undergoes comprehensive training in handling sensitive materials, maintaining chain-of-custody protocols, and adhering to regulatory compliance standards. Our couriers serve as trusted representatives of the healthcare ecosystem.",
  },
  {
    title: "Dedicated to Our Clients",
    body: "We work closely with hospitals, laboratories, clinics, and diagnostic facilities to develop customized delivery solutions. Whether you need same-day delivery, scheduled pickups, or emergency transport, we tailor our services to your requirements.",
  },
  {
    title: "Advanced Tracking & Security",
    body: "From real-time GPS tracking to temperature-controlled transport for sensitive samples, we employ industry-leading technology to maintain the integrity of your shipments. Every delivery is documented, logged, and verified.",
  },
  {
    title: "Unwavering Reliability",
    body: "We've built our reputation on consistency — never missing deadlines, always prioritizing safety, and maintaining the highest standards of customer service. Your success is our success, and we take that responsibility seriously.",
  },
  {
    title: "Your Trusted Partner",
    body: "When you choose On Time Couriers, you're choosing a partner you can trust completely. We're more than a delivery service; we're an extension of your medical team, sharing your commitment to excellence and patient care.",
  },
];

export const SERVICES = [
  { icon: Clock, title: "Same-Day Medical Delivery", body: "Urgent medical samples, documents, and supplies delivered within hours. When timing is critical, we don't miss." },
  { icon: Truck, title: "Scheduled Pickups", body: "Regular, reliable pickup and delivery routes for hospitals, laboratories, clinics, and diagnostic facilities." },
  { icon: Package, title: "Specimen & Sample Transport", body: "Temperature-controlled, chain-of-custody compliant transport for sensitive medical samples and specimens." },
  { icon: MapPin, title: "Hospital & Lab Logistics", body: "Customized delivery solutions tailored to the unique operational needs of healthcare organizations." },
  { icon: Building2, title: "Medical Equipment Delivery", body: "Safe, insured transport of medical devices and equipment with full documentation and verified delivery." },
  { icon: Siren, title: "Emergency Transport", body: "24/7 emergency courier response. Direct, priority handling when lives and patient outcomes depend on speed." },
];

export const WHY_POINTS = [
  { icon: Clock, text: "99.2% on-time delivery rate" },
  { icon: ShieldCheck, text: "Fully insured shipments" },
  { icon: Navigation, text: "Real-time GPS tracking" },
  { icon: UserCheck, text: "Professional, uniformed drivers" },
  { icon: CalendarClock, text: "Same-day & next-day options" },
  { icon: BadgeDollarSign, text: "Competitive transparent pricing" },
  { icon: UserCheck, text: "Dedicated account managers" },
  { icon: Headset, text: "24/7 customer support" },
];

export const STEPS = [
  { num: "01", icon: PhoneCall, title: "Request a Pickup", body: "Call us, fill out the form, or send a message. Tell us what you need delivered and when." },
  { num: "02", icon: PackageCheck, title: "We Collect", body: "Our professional driver arrives at your location, carefully picks up your package, and confirms the details." },
  { num: "03", icon: Truck, title: "In Transit", body: "Your parcel is on the move with real-time GPS tracking. You'll know exactly where it is at all times." },
  { num: "04", icon: Navigation, title: "Delivered On Time", body: "Package delivered safely to the destination with signature confirmation and proof of delivery." },
];

export const FLEET_STATS = [
  { value: "New &", label: "Reliable Vehicles in Fleet" },
  { value: "1000+", label: "Deliveries Completed" },
  { value: "Now", label: "Accepting New Business Clients" },
  { value: "Proudly", label: "Serving the DMV Area" },
];

export const CONTACT_INFO = [
  { icon: PhoneCall, label: "Call us anytime", value: "(888) 271-4255" },
  { icon: Boxes, label: "Drop us a line", value: "Fordss4@courierson.com" },
  { icon: MapPin, label: "Primary contact", value: "Monica Ford" },
  { icon: Clock, label: "We're available", value: "Mon–Sat: 6AM – 10PM" },
];

export const SERVICE_OPTIONS = [
  "Same-Day Delivery",
  "Scheduled Logistics",
  "Fragile / Special Handling",
  "Express Rush Delivery",
  "Business-to-Business",
  "Other",
];
